// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockSection-module--wrapper--c79f7"};